import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'groups';
const BASE_PATH = `${API_ROOT}/groups`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: (groupId) => `${BASE_PATH}/${groupId}`,
    GET: (groupId) => `${BASE_PATH}/${groupId}`,
    LIST: BASE_PATH,
    UPDATE: (groupId) => `${BASE_PATH}/${groupId}`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, groupId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(groupId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(groupId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(groupId)}?${params.toString()}`)).data;
}
function getKey(groupId, props) {
    return [CacheKey, 'get', groupId, props];
}
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.memberId)
        params.append('memberId', props.memberId);
    if (props.vehicleId)
        params.append('vehicleId', props.vehicleId);
    if (props.onlyPending)
        params.append('onlyPending', props.onlyPending.toString());
    if (props.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return [CacheKey, 'list', props];
}
async function update(csrfToken, groupId, props) {
    const form = new FormData();
    form.append('groupId', groupId);
    if (props.name)
        form.append('name', props.name);
    if (props.description)
        form.append('description', props.description);
    if (props.image)
        form.append('image', props.image.blob, props.image.filename);
    if (props.deleteImage !== undefined)
        form.append('deleteImage', String(props.deleteImage));
    return (await (await SecureAxios()).put(PATHS.UPDATE(groupId), form, { headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' } })).data;
}
export default { CacheKey, create, delete_, get, getKey, list, listKey, update };
